import React from "react";
import { useHistory } from "react-router";

import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

const useStyles = makeStyles((theme) => ({
  footer: {
    //position: "absolute",
    //marginTop: theme.spacing(8),
    //paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  logo: {
    cursor: "pointer",
  },
}));

const Footer = (props) => {
  const classes = useStyles();
  const history = useHistory();
  return (
    <Typography component="footer" className={classes.footer}>
      <Box display="flex" justifyContent="center" m={2}>
        <img
          src={props.logo}
          alt="LifeDoc Logo"
          height={100}
          width={250}
          onClick={() => history.push("/")}
          className={classes.logo}
        />
      </Box>
      <Box
        textAlign="center"
        display="flex"
        justifyContent="center"
        color={props.textColor}
        fontWeight="fontWeightLight"
        letterSpacing={2}
      >
        Copyright &copy; {new Date().getFullYear()}. LifeDoc. All rights
        reserved.
      </Box>
    </Typography>
  );
};

export default Footer;
